import { json_headers, request } from './common';

const basePath = () => `${window.configs.API_HOST}/api/connections/synxis`;

export const detectMissingRates = (propertyId: string): Promise<{ status: number; message: string }> => {
  return request(`${basePath()}/detect-missing-rates/${propertyId}`, {
    method: 'POST',
    headers: json_headers,
  });
};
